export default __webpack_public_path__ + "static/media/warning-24px.e3dfd075.svg";